import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

import classNames from './TabPanel.scss';

type TabItem = {
  id: number
  category_id?: string[]
  direction_and_platform?: string[]
  top: string
  translateId: number
  description: string
  title: string
}

type TabPanelProps = {
  className: string
  items: TabItem[]
  getLink(props: Partial<Pick<TabItem, 'category_id' | 'direction_and_platform'>>): string
}

export default function TabPanel({
  className,
  items = [],
  getLink,
}: TabPanelProps) {
  const [active, setActive] = useState<number>(-1)

  return (
    <div className={classNames.tabPanel + ' ' + className}>
      {items.map((item, idx) => {
        return (
          <TabPanelItem
            key={item.id}
            item={item}
            isActive={active === idx}
            getLink={getLink}
            onMouseEnter={() => setActive(idx)}
            onMouseLeave={() => setActive(-1)}
          />
        );
      })}
    </div>
  )
}

type TabPanelItemProps = {
  item: TabItem
  isActive?: boolean
  getLink: TabPanelProps['getLink']
  onMouseEnter(): void
  onMouseLeave(): void
}

export function TabPanelItem({
  isActive = false,
  item,
  getLink,
  onMouseEnter,
  onMouseLeave,
}: TabPanelItemProps) {
  const { t } = useTranslation(['main'])
  const linkTo = getLink(item);
  const TopTag: any = linkTo ? Link : 'div';
  const topTagParams = linkTo ? { to: linkTo } : {};
  const offers_plural = t('offers', { count: parseInt(item.top, 10) });

  return (
    <TopTag
      className={isActive ? classNames.tabPanelItemActive : classNames.tabPanelItem}
      onMouseEnter={onMouseEnter}
      onTouchStart={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onTouchEnd={onMouseLeave}
      {...topTagParams}
    >
      <div className={classNames.itemWrapper}>
        <div className={classNames.itemTop}>{item.top} {offers_plural}</div>
        <div className={classNames.itemTitle}>{item.title}</div>
        <div className={classNames.itemDescription}>
          <div className={classNames.itemDescriptionHeader}>
            {item.description}
          </div>
          <div className={classNames.itemDescriptionBody}>
            {offers_plural}
          </div>
        </div>
      </div>
    </TopTag>
  )
}
